import QRCode from "react-qr-code";
import { CheckCircle2 } from "lucide-react";
import screen1 from "../assets/appscreen1.webp";
import screen2 from "../assets/appscreen2.webp";
import { appstore, playstore } from "../assets";

const IOS_APP = "https://apps.apple.com/us/app/jaaga-digital-property-docs/id6737446238";
const ANDROID_APP = "https://play.google.com/store/apps/details?id=app.jaaga.jaaga_pro1";
// One QR for both stores: /get-app forwards Android to Play and iPhone to the
// App Store (pages/GetApp). Always the live site, so a scan works from any build.
const QR_TARGET = "https://www.jaaga.ai/get-app";

const PERKS = [
  "Order any document in minutes",
  "Track every order live",
  "All property papers in one locker",
  "Free credits when you sign up",
];

const HomeAppBand = () => (
  <section className="mh-sec" aria-labelledby="mh-app-h">
    <div className="mh-appband">
      <div>
        <p className="mh-eyebrow">The JaaGa app</p>
        <h2 id="mh-app-h">Manage your property right from your phone</h2>
        <p>Order documents, track every request and keep all your property papers in one place.</p>
        <ul>
          {PERKS.map((p) => (
            <li key={p}>
              <CheckCircle2 size={18} aria-hidden="true" />
              {p}
            </li>
          ))}
        </ul>
        <div className="mh-getapp">
          <a className="mh-qr" href={QR_TARGET} target="_blank" rel="noopener noreferrer" aria-label="Scan to install the JaaGa app">
            <QRCode value={QR_TARGET} size={98} bgColor="#ffffff" fgColor="#0c2244" />
          </a>
          <div className="mh-badges">
            <a href={IOS_APP} target="_blank" rel="noopener noreferrer">
              <img src={appstore} alt="Download on the App Store" width={768} height={240} />
            </a>
            <a href={ANDROID_APP} target="_blank" rel="noopener noreferrer">
              <img src={playstore} alt="Get it on Google Play" width={756} height={224} />
            </a>
          </div>
        </div>
        <p className="mh-scanhint">Scan with your phone camera to download</p>
      </div>
      <div className="mh-phones" role="img" aria-label="JaaGa app screens">
        <div className="mh-phone">
          <img src={screen1} alt="" loading="lazy" width={600} height={1067} />
        </div>
        <div className="mh-phone">
          <img src={screen2} alt="" loading="lazy" width={600} height={1067} />
        </div>
      </div>
    </div>
  </section>
);

export default HomeAppBand;
